import { render, staticRenderFns } from "./ArticlesAdminDetail.vue?vue&type=template&id=677ee87c&scoped=true"
import script from "./ArticlesAdminDetail.vue?vue&type=script&lang=js"
export * from "./ArticlesAdminDetail.vue?vue&type=script&lang=js"
import style0 from "./ArticlesAdminDetail.vue?vue&type=style&index=0&id=677ee87c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677ee87c",
  null
  
)

export default component.exports